import { BehaviorSubject } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Sponsor } from '@pass-frontend/data-access/common/edge';
import { GQL } from '@pass-frontend/data-access/state-management/apollo';
import { eventBus } from '@pass-frontend/utility/event-bus';

/** A Behavior Subject (a Subject with .value property) */
const currentSponsor = new BehaviorSubject<Sponsor | null>(null);
eventBus
  .query((e) => {
    // Guaranteed to have arrived by the time this is queried - since we've authenticated
    return GQL.next.match(e) && e.payload.operation === 'GET_CURRENT_USER_DATA';
  })
  .pipe(
    // The sponsor in the payload..
    map((e) => e.payload.currentSponsor),
    //  .. when it is present ..
    filter((sponsor) => !!sponsor),
  )
  // .. become updates to our BehaviorSubject
  .subscribe(currentSponsor);

/** @example
 *  ```
 *   // For current value:
 *   const sponsor = useKnownSponsor().value
 *   // For a Promise for a value (if it might not have a value yet)
 *   const sponsor = await firstValueFrom(useKnownSponsor())
 * ```
 */
export const useKnownSponsor = () => {
  return currentSponsor;
};
